// Handle OAuth callback and exchange code for tokens
export const handleOAuthCallback = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  
  if (code) {
    try {
      // Exchange code for tokens
      const tokenResponse = await fetch('https://auth.decodedmusic.com/oauth2/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          grant_type: 'authorization_code',
          client_id: '354arlmd5u14k3td9qn9pfg54b',
          code: code,
          redirect_uri: window.location.origin + window.location.pathname,
        }),
      });

      if (tokenResponse.ok) {
        const tokens = await tokenResponse.json();
        
        // Store tokens
        localStorage.setItem('cognito_token', tokens.id_token);
        localStorage.setItem('access_token', tokens.access_token);
        
        // Clean URL
        window.history.replaceState({}, document.title, '/workspace');
        
        return { success: true, tokens };
      }
    } catch (error) {
      console.error('Token exchange failed:', error);
    }
  }
  
  return { success: false };
};